








import {Vue, Component, Prop} from 'vue-property-decorator'
import Icon from './proxy/Icon.vue'
import Colorable from '../lib/ColorHelper'

@Component({
  name: 'CustomIcon',
  components: {Icon},
})
export default class CustomIcon extends Vue {
  @Prop({}) private url?: string
  @Prop({}) private playfont?: string
  @Prop({}) private payfont?: string
  @Prop({}) private color?: string
  @Prop({}) private disabled?: boolean
  @Prop({}) private large?: boolean
  @Prop({}) private left?: boolean
  @Prop({}) private right?: boolean
  @Prop({}) private dark?: boolean
  @Prop({}) private light?: boolean

  private styleObject: object = {}

  private get bgurl() {
    if (this.url) {
      const bg = {backgroundImage: `url(${this.url})`}
      // Why doesn't it works, WHYYYYYY??!?!?!?
      // this.styleObject['background-image'] = `url(${this.url})`
      // Object.assign(this.styleObject, bg)
      Object.assign(bg, this.styleObject)
      return bg
    }
  }

  private get playfontCode() {
    const pfc: string | null = this.playfont ? `playfont-${this.playfont}` : null
    if (pfc) {
      return pfc
    }
  }

  private get payfontCode() {
    let brand = this.payfont
    if (brand === 'mastercard' || brand === 'maestro') {
      brand += '-alt'
    }
    const pfc: string | null = brand ? `pf-${brand}` : null
    if (pfc) {
      return pfc
    }
  }

  private get classes() {
    const setTextColor = Colorable.setTextColor
    const classes: { [cls: string]: boolean | undefined } = {
      'v-icon--disabled': this.disabled,
      'v-icon--left': this.left,
      'v-icon--right': this.right,
    }
    const payOrPlay = () => {
      const k = this.playfontCode || this.payfontCode
      if (k) {
        classes[k] = true
      }
      classes[this.large ? 'display-1' : 'title'] = true
    }
    payOrPlay()

    if (this.color && setTextColor(this.color).class) {
      for (const colorClass in setTextColor(this.color).class) {
        if (setTextColor(this.color).class.hasOwnProperty(colorClass)) {
          classes[colorClass] = true
        }
      }
    } else if (this.color && setTextColor(this.color).style) {
      Object.assign(this.styleObject, setTextColor(this.color).style)
    }
    return classes
  }
}
